import { Loader, MainContainer } from "components/common";
import { HorizontalBreak, MainCollectionsElement } from "./element";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  CollectionsHeading,
  CollectionsTable,
  CollectionsText,
  BtnContainer,
} from "./element";
import check from "../../assets/check.png";
import { Buttons } from "components/common";
import ethlogo from "../../assets/eth-logo.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { GetCollectionsHook } from "hooks";
import { useEffect, useState } from "react";
import { BsCurrencyDollar } from "react-icons/bs";

function MainCollections() {
  const { data, loading, error, getCollections } = GetCollectionsHook();
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    getCollections("", limit);
  }, []);

  const navigate = useNavigate();
  return (
    <MainCollectionsElement>
      {loading && <Loader content="Loading Collections..." />}
      <MainContainer>
        <CollectionsHeading>Collections</CollectionsHeading>
        <CollectionsText>
          The top NFT collections on Nethty, ranked by floor price, volume and
          other statistics.
        </CollectionsText>
        <HorizontalBreak />
        <CollectionsTable>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Collection</TableCell>
                  <TableCell align="right">24h vol</TableCell>
                  <TableCell align="right">Total vol</TableCell>
                  <TableCell align="right">Owners</TableCell>
                  <TableCell align="right">Items</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.map((row) => (
                    <TableRow key={row._id}>
                      <TableCell component="th" scope="row">
                        <img
                          className="img-fluid me-3"
                          width={40}
                          alt=""
                          src={row.logo}
                        />
                        <p onClick={() => navigate(`/collection/${row?._id}`)}>
                          {row.name}
                        </p>
                        <img className="img-fluid" alt="" src={check} />
                      </TableCell>
                      {/* <TableCell align="right">
                      <img className="img-fluid" alt="" src={ethlogo} />
                      {row.floor}
                      <br />
                      <span>+1.42%</span>
                    </TableCell> */}
                      <TableCell align="right">
                        <BsCurrencyDollar style={{ marginBottom: "3px" }} />
                        {row.volume24h}
                        <br />
                        <span>{row.volumeDiff}%</span>
                      </TableCell>
                      <TableCell align="right">
                        <BsCurrencyDollar style={{ marginBottom: "3px" }} />
                        {row.totalVolume}
                      </TableCell>
                      <TableCell align="right">{row.owners}</TableCell>
                      <TableCell align="right">{row.items.length}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CollectionsTable>
        <BtnContainer>
          <Buttons
            onClick={() => {
              getCollections("", limit + 10);
              setLimit(limit + 10);
            }}
            explore
          >
            Load More
          </Buttons>
        </BtnContainer>
      </MainContainer>
    </MainCollectionsElement>
  );
}

export default MainCollections;
